module.exports = __webpack_public_path__ + "img/unshare.de36b94f.svg";